import { isTesting, isProduction } from "@/consts"

export const httpToWs = (url: string): string => {
    const scheme = isProduction || isTesting ? "wss" : "ws"
    const idx = url.indexOf("://")
    if (idx > 0) {
        return scheme + url.slice(idx)
    } else {
        return url
    }
}

export const stripHashTag = (path: string): string => {
    const idx = path.indexOf("#")
    if (idx >= 0) {
        return path.slice(idx + 1)
    } else {
        return path
    }
}
